import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
import { isActiveInsider } from "../visibilityFunctions/shared-utils";
import { GoToMembershipSettingsCTA, InsiderBenefitsLearnMoreCTA } from "./ctas";
export var BenefitsIA = function BenefitsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return isActiveInsider() ? INSIDER_RETAILER(strictLocalize) : NON_INSIDER_RETAILER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return isActiveInsider() ? GoToMembershipSettingsCTA(strictLocalize) : InsiderBenefitsLearnMoreCTA(strictLocalize);
};
var INSIDER_RETAILER = function INSIDER_RETAILER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_MEMBERSHIP_BENEFITS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize)];
    }
  };
};
var NON_INSIDER_RETAILER = function NON_INSIDER_RETAILER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_MEMBERSHIP_BENEFITS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize)];
    }
  };
};
var INSIDER_MEMBERSHIP_BENEFITS = function INSIDER_MEMBERSHIP_BENEFITS(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "wAVSN/",
    defaultMessage: [{
      "type": 0,
      "value": "À propos de l'abonnement Insider"
    }]
  }) : strictLocalize({
    id: "qTpQWl",
    defaultMessage: [{
      "type": 0,
      "value": "Les avantages de l'abonnement Insider"
    }]
  });
};
var WITH_YOUR_INSIDER_MEMBERSHIP = function WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "ftgnjU",
    defaultMessage: [{
      "type": 0,
      "value": "Avec votre abonnement Insider, vous bénéficiez de la livraison gratuite sur des milliers de marques sélectionnées par Faire. Vous profitez également d'un accès anticipé en exclusivité aux salons professionnels en ligne de Faire et aux marques nouvellement arrivées sur notre site. Pour consulter les détails de votre abonnement Insider, cliquez sur le bouton ci-dessous et rendez-vous dans l'onglet « Abonnement Insider » dans les paramètres de votre compte."
    }]
  });
};
var WHEN_YOU_SIGN_UP_FOR_INSIDER = function WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize) {
  return strictLocalize({
    id: "x20m8m",
    defaultMessage: [{
      "type": 0,
      "value": "Lorsque vous vous abonnez à Insider, vous bénéficiez de la livraison gratuite sur des milliers de marques sélectionnées par Faire. Vous profiterez également d'un accès anticipé en exclusivité aux salons professionnels en ligne de Faire et aux marques nouvellement arrivées sur le site. Pour obtenir ces avantages, il vous suffit de vous inscrire afin de bénéficier d'un essai gratuit de 30 jours. Après la fin de la période d'essai, le mode de paiement de votre choix sera débité mensuellement."
    }]
  });
};